import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { useMockedUser } from 'src/hooks/use-mocked-user';

import { hideScroll } from 'src/theme/css';

import LogoSmall from 'src/components/logo/logo-small';
import { NavSectionMini } from 'src/components/nav-section';

import { useNavData } from './config-navigation';
import { useLayoutConfig } from '../config-layout';
import NavToggleButton from '../common/nav-toggle-button';

// ----------------------------------------------------------------------

export default function NavMini() {
  const { nav } = useLayoutConfig();

  const { user } = useMockedUser();

  const navData = useNavData();

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: nav.W_MINI },
      }}
    >
      <NavToggleButton
        sx={{
          top: 22,
          left: nav.W_MINI - 12,
        }}
      />

      <Stack
        sx={{
          pb: 2,
          height: 1,
          position: 'fixed',
          width: nav.W_MINI,
          borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          backgroundColor: (theme) => theme.palette.background.neutral,
          ...hideScroll.x,
        }}
      >
        <LogoSmall sx={{ mx: 'auto', my: 2 }} />

        <NavSectionMini
          data={navData}
          slotProps={{
            currentRole: user?.role,
          }}
        />
      </Stack>
    </Box>
  );
}
